<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum top-spacing">
      <h5 class="title text-uppercase m-0 c-body2 text-center">
        {{ $t("policyObj.text124") }}
      </h5>
      <div class="content mt-10">
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text125") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text126") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text127") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text128") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text129") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text130") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text131") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text132") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text133") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text134") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text135") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text136") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text137") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text138") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text139") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text140") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text141") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text142") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text143") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text144") }}
        </p>
        <p class="lh-18 ">
          2,2% GTGD + 2.200VND/GD
        </p>
        <p style="font-style: italic;" class="lh-18 ">
          (*) GD: {{ $t("policyObj.text145") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text146") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text147") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text148") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text149") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text150") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text151") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text152") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text153") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text154") }}
        </p>
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text155") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text156") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text157") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text158") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text159") }}
        </p>
        <p class="lh-18 fw-600">
          {{ $t("policyObj.text160") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text161") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text162") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text163") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text164") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text165") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text166") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text167") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text168") }}
        </p>
        <p class="lh-18 fw-600">
          {{ $t("policyObj.text169") }}
        </p>
        <p class="lh-18 fw-600">
          {{ $t("policyObj.text170") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text171") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text172") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text173") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text174") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text175") }}
        </p>
        <p class="lh-18 fw-600">
          {{ $t("policyObj.text176") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text177") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text178") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text179") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text180") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text181") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text182") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "police-delivery",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},
  data() {
    return {
      infoHeader: {
        title: this.$t("termsTransaction"),
        isShowHomeIcon: true,
        isShowMenu: true
      }
    };
  },
  created() {}
};
</script>
<style scoped>
.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .top-spacing {
    padding-top: 60px;
  }
}
</style>
